export default async ({ store, route, redirect }) => {
  const spaceId = route.path.split('/')[2];
  const { currentSpace } = store.state.space;
  const { currentGroup } = store.state.group;

  if (!currentGroup.isCoachGroup && ['FREE', 'LIGHT'].includes(currentSpace.planName)) {
    return redirect(`/space/${spaceId}/video`);
  }
};
